import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "12",
  viewBox: "0 0 13 12",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.6085 9.11416e-05C4.613 -3.03805e-05 4.6175 -3.03805e-05 4.622 9.11416e-05H8.35H8.3635C8.74154 0.0209071 9.10071 0.171962 9.38 0.427591L12.075 3.13459C12.0785 3.13779 12.0818 3.14113 12.085 3.14459C12.3366 3.4273 12.4831 3.78802 12.5 4.16609V7.89259V7.89759C12.4814 8.27402 12.3326 8.6323 12.079 8.91109L12.073 8.91709L12.07 8.92059L9.381 11.5781C9.09695 11.8332 8.73341 11.9823 8.352 12.0001H8.349H4.622C4.2447 11.9834 3.88459 11.8376 3.602 11.5871L3.5955 11.5811L3.591 11.5771L0.928 8.92209C0.669696 8.6403 0.518261 8.27692 0.5 7.89509V4.16609C0.517186 3.78381 0.666313 3.4193 0.922 3.13459L3.5925 0.430091C3.87074 0.17309 4.22981 0.0210447 4.608 9.11416e-05H4.6085ZM9.1075 6.77609C8.96479 7.0435 8.89025 7.34198 8.8905 7.64509C8.8905 8.79709 8.5685 9.74459 7.357 9.74509H6.162C5.95414 9.74503 5.74845 9.70287 5.55733 9.62115C5.36622 9.53943 5.19364 9.41984 5.05 9.26959L3.254 6.87909C3.15604 6.78675 3.09834 6.65957 3.09338 6.52504C3.08842 6.3905 3.13659 6.25942 3.22749 6.16012C3.31839 6.06081 3.44471 6.00126 3.57916 5.99433C3.7136 5.98741 3.84538 6.03366 3.946 6.12309L4.966 7.01359L4.4135 3.19409C4.39589 3.12719 4.39202 3.05741 4.40212 2.98897C4.41223 2.92053 4.4361 2.85485 4.47229 2.79589C4.50849 2.73693 4.55625 2.68592 4.61271 2.64593C4.66917 2.60595 4.73314 2.57782 4.80077 2.56324C4.8684 2.54867 4.93828 2.54795 5.0062 2.56113C5.07411 2.57432 5.13865 2.60113 5.19592 2.63995C5.25318 2.67876 5.30199 2.72879 5.33938 2.78699C5.37678 2.84519 5.40199 2.91037 5.4135 2.97859L5.988 5.65009V2.40309C5.988 2.2673 6.04194 2.13707 6.13796 2.04105C6.23398 1.94503 6.36421 1.89109 6.5 1.89109C6.63579 1.89109 6.76602 1.94503 6.86204 2.04105C6.95806 2.13707 7.012 2.2673 7.012 2.40309V5.64709L7.587 3.10209C7.59665 3.03212 7.62065 2.96489 7.65749 2.90462C7.69433 2.84435 7.74322 2.79234 7.80109 2.75184C7.85897 2.71135 7.92459 2.68324 7.99383 2.66928C8.06308 2.65533 8.13446 2.65582 8.2035 2.67074C8.27255 2.68565 8.33777 2.71466 8.39508 2.75595C8.45239 2.79725 8.50055 2.84993 8.53656 2.9107C8.57256 2.97148 8.59562 3.03903 8.6043 3.10913C8.61298 3.17923 8.60709 3.25037 8.587 3.31809L8.037 6.33009L8.966 4.86709C9.00116 4.80977 9.04727 4.75993 9.10169 4.72043C9.15611 4.68093 9.21778 4.65253 9.28318 4.63686C9.34857 4.62119 9.41641 4.61856 9.48283 4.6291C9.54924 4.63965 9.61293 4.66318 9.67025 4.69834C9.72757 4.7335 9.77741 4.77961 9.81691 4.83403C9.85641 4.88845 9.88481 4.95012 9.90048 5.01552C9.91615 5.08091 9.91879 5.14875 9.90824 5.21517C9.89769 5.28158 9.87416 5.34527 9.839 5.40259L9.1075 6.77609Z",
  fill: "#211F58"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'titleRiskIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#DBDBDB",
  },
  width: {
    type: Number as PropType<number>,
    default: 14,
  },
  height: {
    type: Number as PropType<number>,
    default: 14,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
}

})